import { gql } from 'graphql-tag';

export const deleteContactListSchedule = gql`
  mutation deleteContactListSchedule($id: String) {
    deleteContactListSchedule(id: $id)
  }
`;
